import type { OrgProfileData } from '../stores/org-profile-store';

import adsdroid from './adsdroid.json';
import bbc from './bbc.json';
import deepnote from './deepnote.json';
import jamesbhobbs from './jamesbhobbs.json';
import kraken from './kraken.json';
import remo from './remo.json';
import sykeus from './sykeus.json';

export interface OrgBrandConfig {
  readonly logoUrl: string;
  readonly primaryColor: string;
  readonly secondaryColor: string;
  /** Override for display name (e.g. "BBC" instead of "Bbc"). */
  readonly displayName?: string;
  /** Render the avatar as a circle (for personal/user accounts). */
  readonly circular?: boolean;
}

interface OrgData {
  readonly brand: OrgBrandConfig;
  readonly profile?: Partial<OrgProfileData>;
}

const ORG_REGISTRY: Readonly<Record<string, OrgData>> = {
  adsdroid: adsdroid as OrgData,
  bbc: bbc as OrgData,
  deepnote: deepnote as OrgData,
  jamesbhobbs: jamesbhobbs,
  kraken: kraken as OrgData,
  remo: remo as OrgData,
  sykeus: sykeus as OrgData,
};

export const BRAND_SLUGS = Object.keys(ORG_REGISTRY);

/** Orgs that always appear on the homepage even without repos. */
export const STATIC_ORGS: readonly string[] = [
  'adsdroid',
  'bbc',
  'kraken',
  'remo',
];

export function getOrgBrand(orgName: string): OrgBrandConfig | null {
  return ORG_REGISTRY[orgName.toLowerCase()]?.brand ?? null;
}

/** Returns the brand displayName override, or `null` if none configured. */
export function getOrgDisplayName(orgName: string): string | null {
  return ORG_REGISTRY[orgName.toLowerCase()]?.brand.displayName ?? null;
}

/** Returns the static default profile data for an org, or `undefined` if none. */
export function getOrgDefaultProfile(
  orgName: string,
): Partial<OrgProfileData> | undefined {
  return ORG_REGISTRY[orgName.toLowerCase()]?.profile;
}
